const DEFAULT_PAYMENT_METHODS = [
  { id: 'default-cash', name: 'Cash', slug: 'cash', is_active: true, is_default: true },
  { id: 'default-cheque', name: 'Cheque', slug: 'cheque', is_active: true, is_default: false },
  { id: 'default-bank-transfer', name: 'Bank Transfer', slug: 'bank_transfer', is_active: true, is_default: false }
]

export const getDefaultPaymentMethods = () => (
  DEFAULT_PAYMENT_METHODS.map(method => ({ ...method }))
)
